//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'icon',
    methods:{
      doSome () {
        alert('you are clcik');
      }
    }
};



// WEBPACK FOOTER //
// ./example/pages/icon.vue